import { IDashboard, IWidget } from '@/pages/Dashboards/dashboards.types.ts'
import SidePage from '@/shared/SidePage'
import { useCallback, useState } from 'react'
import CreateWidgetSelectTypeContent from '@/pages/Dashboards/components/CreateWidgetSidePage/CreateWidgetSelectTypeContent'
import CreateWidgetSettingsContent from '@/pages/Dashboards/components/CreateWidgetSidePage/CreateWidgetSettingsContent'
import useHttpLoader from '@/shared/hooks/useHttpLoader.ts'
import dashboardsApi from '@/pages/Dashboards/dashboards.api.ts'
import dashboardsUtils from '@/pages/Dashboards/dashboards.utils.ts'
import dashboardsEvents from '@/pages/Dashboards/events/dashboards.events.ts'

interface IProps {
  open: boolean
  onClose: () => void
  dashboardId: IDashboard['id']
}

const CreateWidgetSidePage = (props: IProps) => {
  const { wait, loading } = useHttpLoader()
  const [step, setStep] = useState<'widget-type' | 'widget-settings'>('widget-type')
  const [type, setType] = useState<IWidget['type']>(null)

  const handleSave = useCallback(
    (settings: IWidget['configuration']['settings']) => {
      wait(dashboardsApi.createWidget(dashboardsUtils.generateWidget(props.dashboardId, type, settings)), (resp) => {
        if (resp.status === 'success') {
          dashboardsEvents.widgetCreated(resp.body)
          props.onClose()
        }
      })
    },
    [type, props.onClose]
  )

  const renderContent = () => {
    switch (step) {
      case 'widget-type':
        return (
          <CreateWidgetSelectTypeContent
            onTypeSelect={(t) => {
              setType(t)
              setStep('widget-settings')
            }}
          />
        )
      case 'widget-settings':
        return (
          <CreateWidgetSettingsContent
            widgetType={type}
            loading={loading}
            onSave={handleSave}
            onCancel={() => setStep('widget-type')}
          />
        )
    }
  }

  return (
    <SidePage
      onClose={props.onClose}
      open={props.open}
      size={type === 'svg' ? 'large' : 'default'}
      style={{ paddingRight: 0 }}
    >
      {renderContent()}
    </SidePage>
  )
}

export default CreateWidgetSidePage
